module.exports = __webpack_public_path__ + "static/media/1988_winter_paralympics1.5ce43b03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1988_winter_paralympics1.jpg
// module id = 961
// module chunks = 0